"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeToken = exports.getToken = exports.setToken = void 0;

var _types = require("../types"); // tslint:disable-next-line: strict-type-predicates


var isBrowser = !!(typeof window !== 'undefined' && window.localStorage);

var setToken = function setToken(token) {
  if (isBrowser) {
    window.localStorage.setItem(_types.TOKEN, token);
  }
};

exports.setToken = setToken;

var getToken = function getToken() {
  if (isBrowser) {
    return window.localStorage.getItem(_types.TOKEN);
  }

  return null;
};

exports.getToken = getToken;

var removeToken = function removeToken() {
  if (isBrowser) {
    window.localStorage.removeItem(_types.TOKEN);
  }
};

exports.removeToken = removeToken;